module.exports = __webpack_public_path__ + "static/img/carousel.03089e45.png";